import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
export default async function getAllLeadsEmails(callback) {
	await firebaseRef.ref('/kavtek_leads/').on('value', (snapshot) => {
		var leadClientsEmailsArr = [];
		var snapData = snapshot.val();
		var allKeys = snapData && Object.keys(snapData);
		if(allKeys !== null && allKeys !== undefined && allKeys.length > 0){
			allKeys.forEach((leadsKey) => {
				var leadClientsEmails = snapData[leadsKey]['clientEmail'];
				var leadClientsSentEmail = snapData[leadsKey]['sentEmail'];
				var leadClients = {
					email: leadClientsEmails,
					sentEmail: leadClientsSentEmail,
				};
				leadClientsEmailsArr.push(leadClients);
			});
		}
		callback(leadClientsEmailsArr);
	});
}
